/**
 * PersonalInfoConsentBox Component
 *
 * Consent modal for personal information handling, shown when the user
 * clicks "Submit employment documents". Displays in the selected language
 * (from the language picker) with title, description including one link
 * (purpose of use and privacy policy), and Agree / Disagree buttons.
 */
import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import './consentBox.css';

export interface PersonalInfoConsentBoxProps {
  /** URL for the "purpose of use and privacy policy" link */
  linkUrl?: string;
  onAgree: () => void;
  onDisagree: () => void;
}

export default function PersonalInfoConsentBox({
  linkUrl = '#',
  onAgree,
  onDisagree,
}: PersonalInfoConsentBoxProps) {
  const { t } = useLanguage();

  return (
    <div className="consent-box__overlay">
      <div className="consent-box consent-box--single-language">
        <div className="consent-box__title-section">
          <h2 className="consent-box__title-ja">{t('consentPersonalInfo.title')}</h2>
        </div>

        <div className="consent-box__description">
          <p className="consent-box__text">
            {t('consentPersonalInfo.descriptionBefore')}{' '}
            <a
              href={linkUrl}
              className="consent-box__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('consentPersonalInfo.linkText')}
            </a>
            {' '}{t('consentPersonalInfo.descriptionAfter')}
          </p>
        </div>

        <div className="consent-box__actions">
          <button
            type="button"
            className="consent-box__btn consent-box__btn--agree"
            onClick={onAgree}
          >
            {t('consentPersonalInfo.agree')}
          </button>
          <button
            type="button"
            className="consent-box__btn consent-box__btn--disagree"
            onClick={onDisagree}
          >
            {t('consentPersonalInfo.disagree')}
          </button>
        </div>
      </div>
    </div>
  );
}
